/**
 * Generate Youtube Iframe
 *
 * @param {string} youtubeId
 * @return {void}
 */
const generateYoutubeIframe = ( youtubeId ) => {

	const iframe = document.createElement( 'iframe' );
	iframe.width = '100%';
	iframe.height = '100%';
	iframe.src = `https://www.youtube.com/embed/${ youtubeId }?autoplay=1&rel=0&showinfo=0&controls=0`;
	iframe.frameborder = '0';
	iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen';
	iframe.allowfullscreen = true;
	iframe.loading = 'lazy';
	iframe.className = 'b-hero-media__source b-hero-media__source--iframe';
	return iframe;

}

document.querySelectorAll( '.b-hero' ).forEach( ( block ) => {

	const triggers = block.querySelectorAll( '.js-youtube-replace' );
	const mediaEl = block.querySelector( '.js-hero-media' );
	const mediaSource = block.querySelector( '.js-media-source' );
	triggers.forEach( ( trigger ) => {

		trigger.addEventListener( 'click', ( event ) => {

			event.preventDefault( );

			const youtubeId = trigger.dataset.youtubeId;
			const iframe = generateYoutubeIframe( youtubeId );
			mediaEl.appendChild( iframe );
			trigger.remove( );
			mediaSource.remove( );


		} );

	} );

} );